import React, { useEffect } from 'react';
import { Grid, Container } from '@material-ui/core';
import Footer from '../Footer/Footer';
import { Spinner } from '@danfoss/webex-ui';
import { useSharedStyles } from '../../sharedStyles/Styles';
import LogoAndBackground from '../Header/LogoAndBackground';
import Information from '../Information/Information';
import { useRedirectData } from './useRedirectData';
import { useTranslation } from 'react-i18next';

export const RedirectToDesktopApp: React.FC = () => {
  const sharedClasses = useSharedStyles();
  const { t } = useTranslation();

  const { isLoading, application, finalRedirectUri } = useRedirectData();

  useEffect(() => {
    if (finalRedirectUri) {
      window.location.href = finalRedirectUri;
    }
  }, [finalRedirectUri]);

  const applicationName = application?.translations?.name ?? application?.name ?? '';

  return isLoading ? (<Spinner visible />) : (
    <>
      <LogoAndBackground classes={sharedClasses} />
      <Container className={sharedClasses.containerRoot}>
        <Container maxWidth="md" className={`${sharedClasses.outerContainer} ${sharedClasses.relativeContainer}`}>
          <Grid container className={sharedClasses.contentContainerRoot}>
            <Grid item xs={12}>
              <Information
                headerText={t('desktop_app_redirect.header')}
                bodyText={t('desktop_app_redirect.body', { application: applicationName })}
                buttonText={t('desktop_app_redirect.button', { application: applicationName })}
                handleButtonClick={() => { window.location.href = finalRedirectUri }}
              />
            </Grid>
          </Grid>
        </Container>
      </Container>
      <Footer contentClass={sharedClasses.footerContent} />
    </>
  );
};

